import { NextPage } from "next";
import { AppProps } from "next/app";
import { NextRouter } from "next/router";
import { ExecutedMessage, SentMessage } from "../../.graphclient";

export type ChainInfo = {
  chainId: number;
  scanUrl: string;
  beaconScanUrl?: string;
  nodeUrl?: string;
  name: string;
};

export type Chain =
  | "goerli"
  | "mainnet"
  | "polygon"
  | "optimism"
  | "gnosis"
  | "arbitrum"
  | "binance"
  | "avalanche";

export type PageWithHeader<P = {}, IP = P> = NextPage<P, IP> & {
  header?: string | ((router: NextRouter) => string);
};

export type PageWithHeaderProps = AppProps & { Component: PageWithHeader };

export const DefaultMessageTableFilters: MessageTableFilters = {
  chain: null,
  origin: null,
  source: null,
  target: null,
  startDate: null,
  endDate: null,
};

export type MessageTableFilters = {
  chain: Chain[] | null;
  origin: string | null;
  source: string | null;
  target: string | null;
  startDate: Date | null;
  endDate: Date | null;
};

export type DeepNonNullable<T> = {
  [P in keyof T]: NonNullable<T[P]>;
};

export type Ensure<T, K extends keyof T> = T & DeepNonNullable<Pick<T, K>>;

export type MessageTableRow = [SentMessage | null, ExecutedMessage | null];

export type ParsedDailySourceData = {
  dailySentBytes: number;
  dailySentMessages: number;
  date: Date;
};
